// all routes
import React, { useEffect } from 'react';
import Routes from './routes/Routes';
import './assets/scss/Theme.scss';
import { AppColors } from './utils/Colors';

const App = () => {
    useEffect(() => {
        document.documentElement.style.setProperty('--primary-color', AppColors.primaryColor);
    }, []);

    return <Routes />;
};

export default App;
